import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './ui/Countdown';
export function CountdownUrgency() {
  return <section className="py-12 bg-navy-700 text-white border-y-4 border-silver/40" data-id="element-36" data-mp="13gupigmvsmgx">
      <div className="container mx-auto px-4 text-center" data-id="element-37" data-mp="1i57lhdlyy5bf">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-38" data-mp="1ddfw36eju5mv">
          <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider mb-6 text-silver-light" data-id="element-39" data-mp="2130d3jr56sti">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>

          <div className="mb-8" data-id="element-40" data-mp="1w4qm7lcgaedp">
            <Countdown initialHours={23} initialMinutes={20} initialSeconds={34} theme="silver" className="shadow-2xl scale-110 md:scale-125 origin-center" data-id="element-41" data-mp="6or3bcj15akv" />
          </div>

          <p className="text-xl font-bold text-silver mb-8" data-id="element-42" data-mp="2jt4icacinrp3">
            ⚠️ Después sube. No vuelve al precio de lanzamiento.
          </p>

          <div className="bg-navy-800/70 rounded-xl p-6 max-w-xl mx-auto border border-silver/25" data-id="element-43" data-mp="2ss82zirc0f5p">
            <p className="font-bold mb-3 flex items-center justify-center gap-2 text-silver-light" data-id="element-44" data-mp="2xig2r8r7grft">
              <span className="w-3 h-3 rounded-full bg-silver animate-pulse" aria-hidden="true" data-id="element-45" data-mp="32i1bgaw6ge5q"></span>
              Cupos al precio de lanzamiento — Quedan pocos
            </p>

            <div className="w-full bg-navy-950 rounded-full h-4 mb-2 overflow-hidden border border-silver/25" data-id="element-46" data-mp="3ch0bj52vn1h4">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '71%'
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="bg-silver h-4 rounded-full" data-id="element-47" data-mp="3gg978fhh99fb"></motion.div>
            </div>
            <p className="text-sm text-silver font-medium text-right" data-id="element-48" data-mp="2kgnguzfz101a">
              71% de los cupos tomados
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}